<script setup lang="ts"></script>
<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM6.38281 19.0303C7.92256 20.2621 9.87476 21 12 21C16.9706 21 21 16.9706 21 12C21 9.87476 20.2621 7.92256 19.0303 6.38281L6.38281 19.0303ZM12 3C7.02944 3 3 7.02944 3 12C3 14.1247 3.7374 16.0766 4.96875 17.6162L17.6162 4.96875C16.0766 3.7374 14.1247 3 12 3Z"
      fill="currentColor"
    />
  </svg>
</template>
